/**
 * Species skin registry index
 */
import { elemental_species_drawers } from './elemental.js';
import { cosmic_species_drawers } from './cosmic.js';

export const SPECIES_SKIN_REGISTRY = {
  ...elemental_species_drawers,
  ...cosmic_species_drawers
};
